<template>
	<form enctype="multipart/form-data">
		<div class="mb-8 flex flex-wrap p-8">
			<TextInput
				v-model="form.subject"
				class="w-full"
				:error="form.errors.subject"
				label="Ämnesrad"
			/>

			<div class="lg:w-1/1 w-full pt-8 flex flex-col">
				<label class="form-label">Underrubrik</label>

				<QuillEditor
					v-model:content="form.preheader"
					ref="description"
					class="pt-6 pb-4"
					label="Content"
					content-type="html"
					:error="form.errors.preheader"
					:options="editorOption"
				/>
				<div v-if="form.errors.preheader" class="form-error">
					{{ form.errors.preheader }}
				</div>
			</div>

			<TextInput
				v-model="form.title"
				class="w-full pt-8"
				:error="form.errors.title"
				label="Rubrik i mail"
			/>

			<div class="lg:w-1/1 w-full pt-8 flex flex-col">
				<label class="form-label">Ingress</label>

				<QuillEditor
					v-model:content="form.preamble"
					ref="description"
					class="pt-6 pb-4"
					label="Content"
					content-type="html"
					:error="form.errors.preamble"
					:options="editorOption"
				/>

				<div v-if="form.errors.preamble" class="form-error">
					{{ form.errors.preamble }}
				</div>
			</div>

			<div class="lg:w-1/1 w-full pt-8 flex flex-col">
				<label class="form-label">Minitext</label>

				<QuillEditor
					v-model:content="form.minitext"
					ref="description"
					class="pt-6 pb-4"
					label="Content"
					content-type="html"
					:error="form.errors.minitext"
					:options="editorOption"
				/>

				<div v-if="form.errors.minitext" class="form-error">
					{{ form.errors.minitext }}
				</div>
			</div>

			<div class="w-full">
				<TextInput
					v-model="form.header_above_products"
					class="w-full pt-8"
					:error="form.errors.header_above_products"
					label="Rubrik ovanför produkter"
				/>
				<div v-if="form.errors.header_above_products" class="form-error">
					{{ form.errors.header_above_products }}
				</div>
			</div>

			<div class="w-full">
				<TextInput
					v-model="form.gcma"
					class="w-full pt-8"
					:error="form.errors.gcma"
					label="GCMA"
				/>
				<div v-if="form.errors.gcma" class="form-error">
					{{ form.errors.gcma }}
				</div>
			</div>
			<div class="w-full pt-8">
				<BaseSelect
					v-model="form.template"
					label="Färgschema"
					class="w-full pr-6 form-input"
					:error="form.errors.template"
					:options="[
						{ name: 'Välj', value: '' },
						{ name: 'Lila (Eliquis)', value: 'purple' },
						{ name: 'Blå (Pfizer)', value: 'blue' }
					]"
				/>
			</div>
			<div class="w-full">
				<div class="w-1/3">
                    <CheckboxInput
                        v-model="form.gcma_status"
                        class="w-full mt-[30px] pr-6"
                        :error="form.errors.gcma_status"
                        label="GCMA-godkänd"
                    />
                </div>
			</div>
			<div class="w-full">
				<div class="w-1/3">
                    <CheckboxInput
                        v-model="form.include_last_order"
                        class="w-full mt-[10px] pr-6"
                        :error="form.errors.include_last_order"
                        label="Inkludera kundens senaste beställning i mailet"
                    />
                </div>
			</div>
			<div class="w-full mt-[30px]">
				<h3 class="font-bold">Filtrera urvalet av mottagare</h3>
			</div>
            <div class="w-full flex mt-[15px] items-center">
                <div class="w-1/2 mr-[15px]">
					<BaseSelect
						v-model="form.last_order_months_ago"
						label="Kunder som inte har gjort någon beställning sedan"
						class="w-full pr-6 form-input"
						:error="form.errors.last_order_months_ago"
						:options="[
							{ name: 'Välj', value: '' },
							{ name: '1 månad innan påminnelsedatum', value: '1' },
							{ name: '2 månader innan påminnelsedatum', value: '2' },
							{ name: '3 månader innan påminnelsedatum', value: '3' },
							{ name: '4 månader innan påminnelsedatum', value: '4' },
							{ name: '5 månader innan påminnelsedatum', value: '5' },
							{ name: '6 månader innan påminnelsedatum', value: '6' },
							{ name: '7 månader innan påminnelsedatum', value: '7' },
							{ name: '8 månader innan påminnelsedatum', value: '8' },
							{ name: '9 månader innan påminnelsedatum', value: '9' },
							{ name: '10 månader innan påminnelsedatum', value: '10' },
							{ name: '11 månader innan påminnelsedatum', value: '11' }]"
					/>
                </div>

                <div class="w-1/2 mr-[15px]">
					<BaseDatepicker
						v-model="form.send_date"
						label="Påminnelsedatum"
						class="w-full pr-6"
						:error="form.errors.send_date"
					/>
                </div>
            </div>

			<div class="w-full flex mt-[30px]">
                <div class="w-1/3 mr-[15px]">
					<label class="form-label">Har köpt någon av dessa produkter</label>
					<VueMultiselect
					v-model="selectedProducts"
					group-label="name"
					track-by="id"
					label="name"
					:options="products"
					:multiple="true"
					:group-select="true"
					:placeholder="__('Type to search')"
					/>
					<div v-if="selectedProducts.length === 0" class="p-2 rounded bg-yellow-100 text-yellow-800 mt-3 text-xs">
						Du har inte valt en produkt ännu. Nu kommer alla som lagt en beställning oavsett produkt få detta utskick.
					</div>
				</div>
                <div class="w-1/3 mr-[15px]">
					<label class="form-label">Är verksam i någon av dessa regioner</label>
					<VueMultiselect
					v-model="selectedRegions"
					group-label="name"
					track-by="id"
					label="name"
					:options="regions"
					:multiple="true"
					:group-select="true"
					:placeholder="__('Type to search')"
					/>
					<div v-if="form.errors.region_ids" class="form-error">
						{{ form.errors.region_ids }}
					</div>
				</div>
				<div class="w-1/3 mr-[15px]">
					<label class="form-label">Har någon av dessa roller</label>
					<VueMultiselect
					v-model="selectedRoles"
					group-label="name"
					track-by="id"
					label="name"
					:options="roles"
					:multiple="true"
					:group-select="true"
					:placeholder="__('Type to search')"
					/>
					<div v-if="form.errors.role_ids" class="form-error">
						{{ form.errors.role_ids }}
					</div>
				</div>
			</div>
			<div class="w-full mt-8 flex items-center justify-center">
				<div
					class="p-8 rounded"
					:class="{
						'bg-yellow-100 text-yellow-800 dark:bg-yellow-200 dark:text-yellow-900': form.estimated_number_of_recipients > 0,
						'bg-red-100 text-red-500 dark:bg-red-100 dark:text-red-600': form.estimated_number_of_recipients === 0,
						'hidden': form.estimated_number_of_recipients === -1
					}">
					Denna filtrering ger {{ form.estimated_number_of_recipients }} mottagare av påminnelsen.
					<p style="font-size:12px;margin-top:10px;">Detta antal är preliminärt och kan förändras fram tills den tidpunkt då utskicket görs.</p>
				</div>
			</div>
			
		</div>

		<div class="flex items-center justify-between border-t border-gray-100 bg-gray-50 px-8 py-4">
			<button
                v-if="form.id"
				class="text-red-600 hover:underline"
                type="button"
                tabindex="-1"
                @click="destroy"
            >
				{{ __('Delete') }}
			</button>

			<div class="flex items-center">
				<a
					class="btn-cta btn-cta--primary mr-[15px]"
					type="button"
					tabindex="-1"
					href="/reminders"
				>
					Tillbaka
				</a>
				<button
					v-if="form.estimated_number_of_recipients && form.status !== 'sent'"
					class="btn-cta btn-cta--primary mr-[15px]"
					type="button"
					tabindex="-1"
					:loading="form.processing"
					@click="save(true)"
				>
					Spara och förhandsgranska
				</button>

				<LoadingButton
					v-if="form.status !== 'sent'"
					type="button"
					class="btn-save"
					:loading="form.processing"
					@click="save(false)"
				>
					Spara
				</LoadingButton>
			</div>
		</div>
	</form>
</template>

<script>
  	import VueMultiselect  from 'vue-multiselect'
	import { QuillEditor } from '@vueup/vue-quill'
	import TextInput 	   from '@/Shared/TextInput'
	import CheckboxInput   from '@/Shared/CheckboxInput'
	import BaseSelect      from '@/Shared/BaseSelect'
	import LoadingButton   from '@/Shared/LoadingButton'
    import BaseDatepicker  from '@/Shared/BaseDatepicker'
	import '@vueup/vue-quill/dist/vue-quill.snow.css'

	export default {
		components: {
			BaseSelect,
			VueMultiselect,
			QuillEditor,
			TextInput,
			CheckboxInput,
			BaseDatepicker,
			LoadingButton,
		},
		props: {
			model: {
				type: Object,
				default: () => ({
					subject: null,
					title: null,
					preheader: null,
					preamble: null,
					minitext: null,
					header_above_products: null,
					gcma: null,
					gcma_status: false,
					last_order_months_ago: null,
					estimated_number_of_recipients: null,
					send_date: null,
					template: null,
					include_last_order: false,
					product_ids: [],
					region_ids: [],
					role_ids: [],
				})
			},
			products: {
				type: Array
			},
			regions: {
				type: Array
			},
			roles: {
				type: Array
			},
			submit: {
				type: Function,
				required: true
			},
			label: {
				type: String,
				default: () => { return 'Create reminder' }
			}
		},
		remember: 'form',
		data() {

			return {
				categories: [],
				companies: [],
				receivers: [],
				selectedCategories: [],
				selectedProducts: [],
				selectedRegions: [],
				selectedRoles: [],
				selectedCompany: null,
				requestIsRunning: false,
				// previewMode: false,
				form: this.$inertia.form(this.model),
				pageIsLoaded: false,
      			editorOption: {
					placeholder: 'Enter content here...',
					readOnly: false,
					theme: 'snow',
        			modules: {
          				toolbar: {
							  container: [
								['bold', 'italic', 'underline', 'strike'],        // toggled buttons
								['blockquote', 'code-block', 'link'],

								[{ 'header': 1 }, { 'header': 2 }],               // custom button values
								[{ 'list': 'ordered'}, { 'list': 'bullet' }],
								[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
								[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
								[{ 'direction': 'rtl' }],                         // text direction

								[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
								[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

								[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
								[{ 'font': [] }],
								[{ 'align': [] }],
								['clean'],
								['customButton'],
							],
							handlers: {
                    			customButton: this.customButton
							},
							initCustomButton() {
								const insertInputButtons = document.querySelectorAll('.ql-customButton')

								for (let btnDom of insertInputButtons) {
									btnDom.classList.add('iconeditor')
									btnDom.classList.add('iconfont')
									btnDom.classList.add('owner-tool-btn')
									btnDom.title = ' Add custom button '
								}
							}
						}
        			}
      			}
			}
		},
		watch: {
			selectedProducts: {
				deep: true,
				handler() {
					this.form.product_ids = this.selectedProducts.map((product) => product.id)
					this.estimateRecipients()
				}
			},
			selectedRegions: {
				deep: true,
				handler() {
					if (this.selectedRegions.length > 0) {
						const selectedIds = this.selectedRegions.map((region) => region.id);

						if (selectedIds.includes(0) && selectedIds.length > 1 && selectedIds[selectedIds.length-1] == 0) {
							// We have more than one region and the last added one was Alla regioner
							this.selectedRegions = [{ id: 0, name: 'Alla regioner' }];
						}

						if (selectedIds.includes(0) && selectedIds.length > 1 && selectedIds[selectedIds.length-1] != 0) {
							// Alla regioner is in list and now a new region was added, keep everything except Alla regioner
							this.selectedRegions = this.selectedRegions.filter((region) => region.id != 0)
						}
					}

					this.form.region_ids = this.selectedRegions.map((region) => region.id)
					this.estimateRecipients()
				}
			},
			selectedRoles: {
				deep: true,
				handler() {
					if (this.selectedRoles.length > 0) {
						const selectedIds = this.selectedRoles.map((region) => region.id);

						if (selectedIds.includes(0) && selectedIds.length > 1 && selectedIds[selectedIds.length-1] == 0) {
							// We have more than one role and the last added one was Alla roller
							this.selectedRoles = [{ id: 0, name: 'Alla roller' }];
						}

						if (selectedIds.includes(0) && selectedIds.length > 1 && selectedIds[selectedIds.length-1] != 0) {
							// Alla roller is in list and now a new role was added, keep everything except all regions
							this.selectedRoles = this.selectedRoles.filter((role) => role.id != 0)
						}
					}

					this.form.role_ids = this.selectedRoles.map((role) => role.id)
					this.estimateRecipients()
				}
			},
			'form.last_order_months_ago': {
				deep: true,
				handler() {
					this.estimateRecipients()
				}
			},
			'form.send_date': {
				deep: true,
				handler() {
					this.estimateRecipients()
				}
			},
		},
		methods: {
			customButton() {
				let selection = window.getSelection()
          		let range 	  = selection.getRangeAt(0)
				let node      = document.createElement('a')

				node.setAttribute('class', 'reminder-button')
				node.setAttribute('href', '')
				node.textContent = 'Beställ mer material'

          		range.setStart(range.endContainer, range.endOffset)
          		range.insertNode(node)
          		range.setEnd(range.endContainer, range.endOffset)

				selection.collapse(range.endContainer, range.endOffset)
			},
			destroy() {
				if (confirm('Är du säker på att du vill ta bort påminnelsen?')) {
					this.$inertia.delete(`/reminders/${ this.form.id }`)
				}
			},
			estimateRecipients() {
				// Make sure request is not running
				if (this.requestIsRunning || !this.pageIsLoaded) {
					return
				}

				if (this.form.last_order_months_ago === null || this.form.send_date === null) {
					return
				}

				// Validate send_date using date parse
				if (Date.parse(this.form.send_date) === NaN) {
					console.log('Invalid date')
					return
				}

				this.requestIsRunning = true
				
				const args = {
						'last_order_months_ago': this.form.last_order_months_ago,
						'send_date': this.form.send_date,
						'product_ids': this.form.product_ids.map((id) => id),
						'region_ids': this.form.region_ids.map((id) => id),
						'role_ids': this.form.role_ids.map((id) => id),
					}

				const queryString = new URLSearchParams(args);

				fetch(`/reminders/estimate-recipients?${queryString}`, {
					method: 'GET',
					headers: {
					'Content-Type': 'application/json',
				}
				}).then((response) => {
					return response.json()
				}).then((data) => {
					this.requestIsRunning = false
					this.form.estimated_number_of_recipients = data.recipients_count ?? -1
				})
			},
			save(andPreview = false) {
				//this.previewMode = mode
				this.submit(this.form, andPreview)
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.editorOption.modules.toolbar.initCustomButton()
          	})

			this.selectedProducts = this.form.product_ids.map((id) =>
				this.products.find((product) => product.id === id)
			);

			if (this.form.region_ids.length > 0) {
				this.selectedRegions = this.form.region_ids.map((id) =>
					this.regions.find((region) => region.id === id)
				);
			} else {
				this.selectedRegions = [{ id: 0, name: 'Alla regioner' }]
			}

			if (this.form.role_ids.length > 0) {
				this.selectedRoles = this.form.role_ids.map((id) =>
					this.roles.find((role) => role.id === id)
				);
			} else {
				this.selectedRoles = [{ id: 0, name: 'Alla roller' }]
			}

			document.querySelector('.js-overflow-hidden').classList.remove('md:overflow-hidden');

			this.pageIsLoaded = true
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style>
.ql-editor strong {
	font-weight: 700;
}
</style>
